export default __webpack_public_path__ + "static/interview-46d5b2bfd1699e849394ff0aee01c989.svg";